export default __webpack_public_path__ + "static/media/5-warranty.5732f909.svg";